import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const PeriodText = styled(Typography)({
  fontSize: '12px !important',
  lineHeight: '1.25 !important',
  fontWeight: 500,
});

export default PeriodText;
